import APIRequest from "../utils/APIRequest";

export default class Statistic {

  static getWabaStatistic = async (wabaId, start, end, granularity, phoneNumber) => {
    return await APIRequest.set(`v1/waba/statistic/${wabaId}?start=${Math.floor(start/1000)}&end=${Math.floor(end/1000)}&granularity=${granularity}${phoneNumber ? `&phoneNumber=${phoneNumber}` : ""}`, 'GET');
  }

  static getWabaConversationStatistic = async (wabaId, start, end, granularity, phoneNumber) => {
    return await APIRequest.set(`v1/waba/conversation_statistic/${wabaId}?start=${Math.floor(start/1000)}&end=${Math.floor(end/1000)}&granularity=${granularity}${phoneNumber ? `&phoneNumber=${phoneNumber}` : ""}`, 'GET');
  }

}
